import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
import Accordion, { Props as AccordionProps } from '@classify/react-core-components/Accordion';
import { styled } from '@classify/react-core-components/styles';
export interface Props extends AccordionProps {
  title?: string;
  image?: string;
  items: Array<{
    question: string;
    answer: string;
    disabled?: boolean;
  }>;
}
const ImageContainer = styled(Box)(({
  theme: {
    breakpoints
  }
}) => ({
  maxWidth: 130,
  [breakpoints.up('sm')]: {
    maxWidth: 160
  },
  [breakpoints.up('md')]: {
    maxWidth: 200
  },
  [breakpoints.up('lg')]: {
    maxWidth: 230
  }
}));
const Image = styled('img')(() => ({
  maxWidth: '100%'
}));
const FAQ = t0 => {
  const $ = _c(30);
  const {
    items,
    expandAriaLabel,
    image,
    title,
    sx
  } = t0;
  let mappedItems;
  let t1;
  let t2;
  if ($[0] !== items) {
    mappedItems = items.map(_temp);
    t1 = "application/ld+json";
    t2 = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: mappedItems.map(_temp2)
    });
    $[0] = items;
    $[1] = mappedItems;
    $[2] = t1;
    $[3] = t2;
  } else {
    mappedItems = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <script type={t1}>{t2}</script>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      xs: "column",
      sm: "row"
    };
    t5 = {
      xs: 4,
      md: 8
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== image) {
    t6 = image && <ImageContainer><Image src={image} alt="" /></ImageContainer>;
    $[9] = image;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      flex: 1,
      maxWidth: 768
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = title && <Typography variant="h3" component="h2" sx={{
      marginBottom: 4
    }}>{title}</Typography>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      heading: {
        component: "h3"
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== expandAriaLabel || $[16] !== mappedItems) {
    t10 = <Accordion items={mappedItems} expandAriaLabel={expandAriaLabel} slotProps={t9} />;
    $[15] = expandAriaLabel;
    $[16] = mappedItems;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <Box sx={t7}>{t8}{t10}</Box>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t6) {
    t12 = <Stack direction={t4} gap={t5}>{t6}{t11}</Stack>;
    $[21] = t11;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== sx || $[25] !== t12) {
    t13 = <Box sx={sx}>{t12}</Box>;
    $[24] = sx;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t3) {
    t14 = <>{t3}{t13}</>;
    $[27] = t13;
    $[28] = t3;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default FAQ;
function _temp(t0) {
  const {
    question,
    answer,
    disabled
  } = t0;
  return {
    title: question,
    content: answer,
    disabled
  };
}
function _temp2(faqItem) {
  return {
    "@type": "Question",
    name: faqItem.title,
    acceptedAnswer: {
      "@type": "Answer",
      text: faqItem.content
    }
  };
}